import SimpleLightBox from "simplelightbox";

window.simpleLightBox = new SimpleLightbox('a.resize-image', {fileExt: 'png|jpg|jpeg|gif|webp|avif',download: 'Скачать оригинал'});
